export const OS_CONFIG_STATUS_POLL_LIMIT = 30
export const OS_CONFIG_STATUS_POLL_MS = 2000

const OPEN_RUN = new Set(['QUEUED', 'RUNNING'])

export function osConfigRunStillOpen(status) {
  return status == null || OPEN_RUN.has(status)
}

export function osConfigStatusRead(integrationId) {
  return { method: 'GET', path: `/${integrationId}/runs` }
}
